export interface XY {
  x: number;
  y: number;
}

/** The radius of a dot, and of the one under the pointer, in px. */
const POINT_RADIUS = 6;
export const POINT_HOVER_RADIUS = 8;

/** The height of a scatter, in px, shared so the scatters line up. */
export const SCATTER_HEIGHT = 270;

// font size of the labels the plugins paint onto the canvas (anchor lines,
// the "no change" marker): a step below the tick font so they read as notes
export const ANNOTATION_FONT_SIZE_PX = 11;

// one chart.js dataset per zone, styled the same way in every settlement scatter
export const scatterDataset = <P>(
  pts: readonly P[],
  toXY: (p: P) => XY,
  fill: string,
  edge: string,
) => ({
  data: pts.map(toXY),
  parsing: false as const,
  pointRadius: POINT_RADIUS,
  pointHoverRadius: POINT_HOVER_RADIUS,
  backgroundColor: fill,
  borderColor: edge,
  borderWidth: 1,
  // the dot under the pointer grows, and keeps its colours
  pointHoverBackgroundColor: fill,
  pointHoverBorderColor: edge,
  pointHoverBorderWidth: 1,
});

// y carries the 0…1 normalised claim value, which only orders the dots
// vertically, so the axis draws no ticks or grid (ZonedScatter adds its
// title and line); the padding keeps edge dots off the frame
export const normalisedYAxis = {
  min: -0.05,
  max: 1.05,
  ticks: { display: false },
  grid: { display: false },
};
